import { render, staticRenderFns } from "./Variants.vue?vue&type=template&id=46b8a5d0&scoped=true&lang=pug"
import script from "./Variants.vue?vue&type=script&lang=js"
export * from "./Variants.vue?vue&type=script&lang=js"
import style0 from "./Variants.vue?vue&type=style&index=0&id=46b8a5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8a5d0",
  null
  
)

export default component.exports